import { render, staticRenderFns } from "./BoardCard.vue?vue&type=template&id=f23b272e&scoped=true"
import script from "./BoardCard.vue?vue&type=script&lang=js"
export * from "./BoardCard.vue?vue&type=script&lang=js"
import style0 from "./BoardCard.vue?vue&type=style&index=0&id=f23b272e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23b272e",
  null
  
)

export default component.exports